import { getUrls } from "../util/General";

export const routes = {
    root: getUrls().api,
    base: getUrls().api + "/vam",
    api: getUrls().api + "/vam",
    apiGen: getUrls().api + "/gen",
    gen: "/gen",
};

export const app = {
    name: "Asistencia Médica",
    prodeseg: true,
    showPerfil: false,
    showLinkToWeb: true,
    linkToWeb: "https://www.google.com.ec", // todo de alguna manera saber la web a donde regresa
};
